import { createReducer, on } from '@ngrx/store';
import { SignUpSmartSearchState } from '@shared-lib/models/sign-up/sign-up-smart-search.state';
import {
  clearSignUpSmartSearchFromStorage,
  loadSignUpSmartSearchFromStorageSuccess,
  setSignUpSmartSearchForm,
  setSignUpSmartSearchState,
} from '@shared/store/sign-up/smart-search/smart-search.actions';

export const signUpSmartSearchInitialState: SignUpSmartSearchState = {
  entity: null,
  loading: true,
  errors: null,
};

export const signUpSmartSearchReducer = createReducer(
  signUpSmartSearchInitialState,
  on(loadSignUpSmartSearchFromStorageSuccess, (_, { state }): SignUpSmartSearchState => ({ ...(state ?? signUpSmartSearchInitialState) })),
  on(
    setSignUpSmartSearchState,
    (_, state): SignUpSmartSearchState => ({ entity: state.entity, loading: state.loading, errors: state.errors }),
  ),
  on(
    setSignUpSmartSearchForm,
    (state, formData): SignUpSmartSearchState => ({
      ...state,
      entity: {
        buyingProcessStage: formData.buyingProcessStage,
        mortgageProductId: formData.mortgageProductId,
        loanAmount: formData.loanAmount,
        basicDetails: formData.basicDetails,
        initialRate: formData.initialRate,
        liveResults: formData.liveResults,
      },
      loading: false,
    }),
  ),
  on(clearSignUpSmartSearchFromStorage, () => ({
    ...signUpSmartSearchInitialState,
  })),
);
